module.exports = __webpack_public_path__ + "assets/radio_check-709367.svg";